import { t } from "i18next";
import { cloneDeep, get } from "lodash";
import { GlobalAuthFetch } from "../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";
import { FetchMethodType } from "../../../../Utils/GlobalVariables/Fetch/MethodsType";
import { NotificationManager } from "react-notifications";



export const onSubmit = async (values, props) => {
  const { setIsLoading } = props;
  setIsLoading(true);
 
  if(props?.documentType === "FaVatAndReport"){
    await sendFaVatAndReport(values, props, setIsLoading);
  }

  if(props?.documentType === "ServiceOrder"){
    await sendServiceOrder(values, props, setIsLoading);
  }

  props.handleHide();
  NotificationManager.success(t("global:success"));
  setIsLoading(false);
};

export const onValidate = (values, props) => {
  const errors = {};

  if(props?.documentType === "ServiceOrder"){
    return errors;
  }

  if (!values.emails && !Boolean(props?.optimaCheckBox)) {
    errors.emails = t("global:PrintDocument.errors.emails");
  }

  if (!values.report && !values.faVat && Boolean(props?.optimaCheckBox)) {
    errors.faVat = t("global:PrintDocument.errors.faVat");
    errors.report = t("global:PrintDocument.errors.report");
  }

  return errors;
};

const sendFaVatAndReport = async (values, props, setIsLoading )=>{
  const data = cloneDeep(values);

  if (typeof data?.emails === "object") data.emails = data?.emails?.uuid;

  let emails = data?.emails;

  const formData = new FormData();
  formData.append("documentType", "FaVatAndReport");
  const generateDockument = await props?.getDocumentFile();

  let dockumentToSend = [generateDockument];
  let reckoningWasSent = {};
  if (Boolean(props?.optimaCheckBox)) {
    const printData = JSON.parse(sessionStorage.getItem("printData"));
    emails = printData?.generateFromRentContract?.accountReceiverEmail
    dockumentToSend = [];

    reckoningWasSent.uuid = printData?.uuid

    if (Boolean(values?.report)) {
      dockumentToSend.push(generateDockument);
      reckoningWasSent.sentReport = true;
    }

    if (Boolean(values?.faVat)) {
      const optimaId = printData.optimaDocumentId;
      if (optimaId === null) {
        NotificationManager.error(
          t("global:PrintDocumentEmailForm.noGenerateFaVat")
        );
        props.handleHide();
        return;
      }
      const {
        payload
      } = await GlobalAuthFetch({
        path: `/optima/documentPDF/${optimaId}`,
        addons: { responseType: "blob" },
      });
      const data = payload?.data;

      if (payload?.status !== 200) {
        NotificationManager.error(
          t("global:PrintDocumentEmailForm.noFaVatInOptima")
        );
        props.handleHide();
        return;
      }

      const file = new File([data], `${printData.optimaFaVatNumber}.pdf`);
      dockumentToSend.push(file);
      reckoningWasSent.sentFaVat = true;
    }
  }

  formData.set("emails", emails);
  for (const doc of dockumentToSend) {
    formData.append("document", doc);
  }

  const { payload } = await GlobalAuthFetch({
    path: "/mail/documentSend",
    method: FetchMethodType.post,
    data: formData,
    addons: {
      headers: {
        "Content-Type": "multipart/form-data;",
      },
    },
  });

  if (payload?.status > 200 || !payload?.status) {
    setIsLoading(false);
    return;
  }

  if (Boolean(reckoningWasSent?.sentFaVat) || Boolean(reckoningWasSent?.sentReport)) {
    await GlobalAuthFetch({
      path: "/reckoning/wasSent",
      method: FetchMethodType.patch,
      data: reckoningWasSent
    });
  }
  const printData = JSON.parse(sessionStorage.getItem("printData"));

  const reckoningSent = {
    sentTo: emails,
    reckoning: { uuid: printData.uuid }
  }

  await GlobalAuthFetch({
    path: "/reckoning/addReportSent",
    method: FetchMethodType.patch,
    data: reckoningSent
  });
  
}

const sendServiceOrder = async (values, props, setIsLoading )=>{
  const data = cloneDeep(values);

  let emails = data?.emails?.map(el=> el.value).join(",")|| get(data,"email",null);

  if(!emails){
    NotificationManager.error(("global:PrintDocument.errors.notfoundemails"));
    return;
  }

  const formData = new FormData();
  formData.append("documentType", "ServiceOrder");
  const generateDockument = await props?.getDocumentFile();

  let dockumentToSend = [generateDockument];

  formData.set("emails", emails);
  for (const doc of dockumentToSend) {
    formData.append("document", doc);
  }

  const { payload } = await GlobalAuthFetch({
    path: "/mail/documentSend",
    method: FetchMethodType.post,
    data: formData,
    addons: {
      headers: {
        "Content-Type": "multipart/form-data;",
      },
    },
  });

  if (payload?.status > 200 || !payload?.status) {
    setIsLoading(false);
    return;
  }  
}